import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { checkUserInfo } from '@miro-site/core/src/utils';
import { Datalayer, getAnalytics } from '@miro-site/analytics';

var useAnalytics = function useAnalytics() {
  var router = useRouter();
  var analytics = getAnalytics();
  useEffect(function () {
    if (!analytics) {
      return;
    }

    var trackPageView = function trackPageView(url) {
      setTimeout(function () {
        var _ref = checkUserInfo() || {},
            userId = _ref.id;

        analytics.sendEvent(new Datalayer('pageview', {
          pagePath: url,
          pageTitle: document.title,
          userId: userId
        }));
      }, 500);
    };

    trackPageView(router.basePath + router.asPath);
    router.events.on('routeChangeComplete', trackPageView);
    return function () {
      router.events.off('routeChangeComplete', trackPageView);
    };
  }, [analytics]);
  return analytics;
};

export default useAnalytics;